export default __webpack_public_path__ + "static/media/beta-al.6fe3c09f.jpg";